import { render, staticRenderFns } from "./tab_page_with_pager.vue?vue&type=template&id=2b98fd51&scoped=true&"
import script from "./tab_page_with_pager.vue?vue&type=script&lang=js&"
export * from "./tab_page_with_pager.vue?vue&type=script&lang=js&"
import style0 from "./tab_page_with_pager.vue?vue&type=style&index=0&id=2b98fd51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98fd51",
  null
  
)

export default component.exports